<template>
  <header class="gc-px-0 gc-flex gc-items-center gc-mb-4 gc-pb-4 gc-border-b-2">
    <gc-row>
      <gc-col v-show="!hideBackButton" cols="4">
        <gc-button v-if="onPrev" color="#D2D2D2" outlined @click="onPrev">
          <font-awesome-icon
            :icon="faArrowLeft"
            class="gc-mr-4 gc-text-black"
          />
          <span class="gc-text-black gc-font-normal">
            {{ $t('general.button.back') }}</span
          >
        </gc-button>
      </gc-col>
      <gc-col cols="12" :sm="`${hideBackButton ? 12 : 8}`">
        <h2
          :class="[
            'gc-text-primary gc-text-2xl',
            { 'gc-text-center': hideBackButton },
          ]"
        >
          {{ $t(title) }}
        </h2>
      </gc-col>
    </gc-row>
  </header>
</template>

<script lang="ts">
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { defineComponent } from '@vue/composition-api';
import GcButton from '@/components/primitives/GcButton.vue';
import GcCol from '@/components/primitives/GcCol.vue';
import GcRow from '@/components/primitives/GcRow.vue';

export default defineComponent({
  components: {
    GcRow,
    GcCol,
    GcButton,
  },
  props: {
    title: { type: String, required: true },
    onPrev: { type: Function, required: false },
    hideBackButton: { type: Boolean, required: false },
  },
  setup: (props) => ({
    props,
    faArrowLeft,
  }),
});
</script>
